
import request from '@/utils/request'

export function getPageList(data) {
    return request({
        url: 'WorkerTenant/getPageList',
        method: 'post',
        data
    })
}

export function deleteObj(data) {
    return request({
        url: 'WorkerTenant/delete',
        method: 'post',
        data
    })
}

export function getAll(data) {
    return request({
        url: 'WorkerTenant/getAll',
        method: 'post',
        data
    })
}
